import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
//import { Intercom } from 'ng-intercom';
import { CommonService } from "../shared/common.service";
import { MessagingService } from "../serivce/messaging.service";

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.css"],
})
export class MainComponent implements OnInit {
  constructor(
    //public intercom: Intercom,
    public Common: CommonService,
    private messagingService: MessagingService,
    private cdr: ChangeDetectorRef
  ) {}

  title: "push-notification";
  message: any;

  ngOnInit() {
    this.messagingService.requestPermission();
    this.messagingService.receiveMessage();
    if ("BroadcastChannel" in window) {
      const broadcast = new BroadcastChannel("firebase-message-channel");
      broadcast.onmessage = (event) => {
        if (event.data && event.data.payload) {
          this.message = {
            title: event.data.payload.notification.title,
            body: event.data.payload.notification.body,
          };
          // this.message = msg;
          // if (this.message == "" || !this.message) {
          //   return;
          // }
          this.cdr.detectChanges();
          console.log(this.message, "Received background message");

          const notification = document.querySelector(".notify");
          notification.classList.add("show-notification");
          setTimeout(() => {
            notification.classList.remove("show-notification");
          }, 5000);
        }
      };
    } else {
      console.error("BroadcastChannel is not supported in this browser.");
    }
    // this.messagingService.currentMessage.subscribe((msg) => {
    //   // debugger;
    //   this.message = msg;
    //   if (this.message == "" || !this.message) {
    //     return;
    //   }
    //   console.log(this.message, "msge");
    //   // setTimeout(() => {
    //   //   this.message = null;
    //   // }, 5000);

    //   // if(this.message != ''){
    //   const notification = document.querySelector(".notify");
    //   notification.classList.add("show-notification");
    //   setTimeout(() => {
    //     notification.classList.remove("show-notification");
    //   }, 5000);
    // });

    let a = [{ number: 19, value: 110 }];
    for (let i = 1; i < 10; i++) {
      let number = a[0]["number"] - i;
      let value = a[0]["value"] - i * 10;

      a.push({ number: number, value: value });
    }

    // console.log('final',a);

    let user = this.Common.getUser();
    // this.intercom.boot({
    //   app_id: "bn64enia",
    //   name: "Admin", // Full name
    //   email: user.email,
    //   created_at: user.iat ,
    //   // Supports all optional configuration.
    //   widget: {
    //     "activator": "#intercom"
    //   }
    // });
  }
}
